import {
	type ProjectType,
	SERVICE_DESK_PROJECT,
	CORE_PROJECT,
} from '@jira/platform__project-types/src/project-types.tsx';

export const transformProjectType = (projectType?: ProjectType): string => {
	if (!projectType) {
		return 'none';
	}
	if (projectType === SERVICE_DESK_PROJECT) {
		return 'serviceManagement';
	}
	if (projectType === CORE_PROJECT) {
		return 'workManagement';
	}
	return projectType;
};
